import { useCallback, useState } from 'react';

export const useOpen = (initialState?: boolean) => {
  const [isOpen, setIsOpen] = useState(Boolean(initialState));

  const open = useCallback(() => setIsOpen(true), []);

  const close = useCallback(() => setIsOpen(false), []);

  const toggle = useCallback(
    (value?: boolean) =>
      value !== undefined
        ? setIsOpen(value)
        : setIsOpen((prevIsOpen) => !prevIsOpen),
    [],
  );

  return { close, isOpen, open, toggle };
};
